import { useState } from 'react'
import { motion } from 'framer-motion'
import './StarRating.css'

export default function StarRating({ value = 0, onChange }) {
  const [hoveredStar, setHoveredStar] = useState(null)

  const handleClick = (star) => {
    onChange(star)
  }

  const getStarDisplay = (starIndex) => {
    const displayValue = hoveredStar !== null ? hoveredStar : value
    return starIndex <= displayValue ? '⭐' : '☆'
  }

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <motion.button
          type="button"
          key={star}
          className={`star ${star <= (hoveredStar || value) ? 'filled' : ''}`}
          onClick={() => handleClick(star)}
          onMouseEnter={() => setHoveredStar(star)}
          onMouseLeave={() => setHoveredStar(null)}
          whileTap={{ scale: 0.9 }}
          whileHover={{ scale: 1.2 }}
          transition={{ type: 'spring', stiffness: 400, damping: 17 }}
        >
          {getStarDisplay(star)}
        </motion.button>
      ))}
    </div>
  )
}
